import React from 'react'
import BlogNav from './components/BlogNav'
import YourPosts from './components/YourPosts'
import { Container } from 'react-bootstrap'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom/cjs/react-router-dom'
import firebase from 'firebase/compat/app'
import ImageSkeleton from './components/skeletons/ImageSkeleton'
import { gsap } from 'gsap'
import "./Profile.scss"
import { useAuth } from './context/AuthContext'
import { BiCurrentLocation } from "react-icons/bi"
import LocationDisplay from './components/Flag/LocationDisplay'

function Profile() {
    const { currentUser } = useAuth();

    useEffect(() => {
        return () => {
            gsap.to(".App", { duration: .0, css: { visibility: 'visible' } })
        };
    }, []);
    const [loading, setLoading] = useState(false);
    const [posts, setPosts] = useState([]);
    const [details, setDetails] = useState([]);
    useEffect(() => {
        setLoading(true);
        // Fetch all posts from Firestore for posts with images
        const fetchPosts = async () => {

            const postsRef = firebase.firestore().collection('Posts').where('uid', '==', currentUser.uid);
            const snapshot = await postsRef.get();
            const postsData = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
            setPosts(postsData);

            setLoading(false);
        };
        fetchPosts();
    }, [currentUser]);

    useEffect(() => {
        setLoading(true);
        // Fetch user details from Firestore
        const fetchDetails = async () => {
            const usersRef = firebase.firestore().collection('users');
            const query = usersRef.where('uid', '==', currentUser.uid).limit(1); // Limit 1 to fetch only the first matching document
            const snapshot = await query.get();

            if (!snapshot.empty) {
                snapshot.forEach((doc) => {
                    setDetails(doc.data());
                });
            } else {
                console.log('User document not found');
            }

            setLoading(false);
        };

        fetchDetails();
    }, [currentUser]);

    const postsPerPage = 100;
    return (
        <>
            <BlogNav />
            <Container fluid className='fluidContained'>
                <Row>
                    <Col xs={4}>



                        <div className="yourDetails" key={details.uid}>
                            <div className="profileImgery">
                                <img src={details.photoURL} alt="" />
                            </div>
                            <div className="AllDets">
                                <h3>{details.displayName}</h3>
                                <p>{details.bio}</p>
                                <div className="local">
                                    <p><BiCurrentLocation /> </p>
                                    <p> <LocationDisplay /></p>
                                </div>
                                <button>Edit Profile</button>
                            </div>

                        </div>

                    </Col>
                    <Col >
                        <div className="posters">
                            <div className="hedf">
                                <p>Your Posts</p>
                            </div>
                            {loading ? (
                                <Row xs={1} md={4}>
                                    {[...Array(postsPerPage)].map((_, index) => (
                                        <Col key={`skeleton_${index}`} className='col-sm'>
                                            <ImageSkeleton />
                                        </Col>
                                    ))}
                                </Row>
                            ) : (
                                <Row>
                                    {posts.map((post, index) => (
                                        <Col key={post.id} className='col-sm posty'>
                                            <Link to={`/blog/${post.id}`} onClick={(e) => e.stopPropagation()}>
                                                <div className="profile-sect">
                                                    <YourPosts
                                                        id={post.id}
                                                        name={post.name}
                                                        Content={post.Content}
                                                        Title={post.Title}
                                                        PhotoUrl={post.PhotoUrl}
                                                        Time={post.Time}
                                                        index={index}


                                                    />
                                                </div>
                                            </Link>
                                        </Col>
                                    ))}
                                </Row>

                            )}
                        </div>
                    </Col>
                </Row>
            </Container>

        </>
    )
}

export default Profile
